const footer = {
  state: {
    token: null,
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
  },

  actions: {

  }
}

export default footer
